import { render, staticRenderFns } from "./DeviceView.vue?vue&type=template&id=1df6418c&scoped=true"
import script from "./DeviceView.vue?vue&type=script&lang=js"
export * from "./DeviceView.vue?vue&type=script&lang=js"
import style0 from "./DeviceView.vue?vue&type=style&index=0&id=1df6418c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6418c",
  null
  
)

export default component.exports